import lrDataList from './_src/lrDataList.vue'

lrDataList.install = function(Vue) {
  Vue.component(lrDataList.name, lrDataList)
}

export default lrDataList